var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogonero(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 808.62 473.94",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M807.96,225.57v180.27c0,37.55-30.55,68.1-68.1,68.1H68.1c-37.55,0-68.1-30.55-68.1-68.1V68.17C0,30.62,30.55.07,68.1.07h514.36v41.23H68.1c-14.81,0-26.87,12.05-26.87,26.87v337.66c0,14.81,12.05,26.87,26.87,26.87h671.76c14.81,0,26.87-12.05,26.87-26.87v-180.27h41.23Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 606.6,
    cy: 202.02,
    r: 28.16
  }), /*#__PURE__*/React.createElement("path", {
    d: "M693.35,202.02h-41.23c0-25.09-20.41-45.51-45.51-45.51v-41.23c47.83,0,86.74,38.91,86.74,86.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M750.83,202.02h-41.23c0-56.79-46.2-102.99-102.99-102.99v-41.23c79.52,0,144.22,64.7,144.22,144.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M808.62,202.02h-41.23c0-88.66-72.13-160.78-160.78-160.78V0c111.39,0,202.02,90.62,202.02,202.02Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M72.07,70.14h61.85c33.4,0,56.49,15.46,56.49,51.13s-19.79,52.78-55.05,52.78h-22.89v51.54h-40.41V70.14ZM112.48,141.48h6.8c14.64,0,29.07,0,29.07-18.97s-13.4-19.79-29.07-19.79h-6.8v38.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.97,144.99c0,50.31-36.08,85.77-85.98,85.77s-85.98-35.46-85.98-85.77c0-47.01,41.24-80,85.98-80s85.98,32.99,85.98,80ZM240.07,145.19c0,26.8,19.79,46.39,43.92,46.39s43.92-19.59,43.92-46.39c0-21.44-19.79-41.03-43.92-41.03s-43.92,19.59-43.92,41.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.36,191.38h48.45v34.23h-88.86V70.14h40.41v121.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.14,225.6h-40.41V70.14h40.41v155.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.44,403.73h-50.31l-38.14-59.79h-.41v59.79h-40.41v-155.46h60.41c30.72,0,54.02,14.64,54.02,47.83,0,21.44-11.96,40-34.02,43.92l48.86,63.71ZM112.57,317.96h3.92c13.2,0,28.04-2.47,28.04-19.38s-14.84-19.38-28.04-19.38h-3.92v38.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.9,376.72l-10.72,27.01h-42.89l59.79-155.46h44.12l58.55,155.46h-43.09l-10.1-27.01h-55.67ZM287.14,296.31h-.41l-16.7,49.48h33.61l-16.49-49.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.07,248.27h57.32c43.3,0,78.97,34.02,78.97,77.73s-35.87,77.73-78.97,77.73h-57.32v-155.46ZM413.48,369.5h9.07c24.12,0,44.74-13.2,44.74-43.5,0-27.83-18.35-43.5-44.33-43.5h-9.48v87.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M558.48,403.73h-40.41v-155.46h40.41v155.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M739.26,323.48c0,50.31-36.08,85.77-85.98,85.77s-85.98-35.46-85.98-85.77c0-47.01,41.24-80,85.98-80s85.98,32.99,85.98,80ZM609.37,323.68c0,26.8,19.79,46.39,43.92,46.39s43.92-19.59,43.92-46.39c0-21.44-19.79-41.03-43.92-41.03s-43.92,19.59-43.92,41.03Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogonero);
export default __webpack_public_path__ + "static/media/LOGO NERO.d676e318e44e127e7b22b036e1100a82.svg";
export { ForwardRef as ReactComponent };